import { render, staticRenderFns } from "./TypographyTypeSelect.vue?vue&type=template&id=183d71f8&scoped=true&"
import script from "./TypographyTypeSelect.vue?vue&type=script&lang=js&"
export * from "./TypographyTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./TypographyTypeSelect.vue?vue&type=style&index=0&id=183d71f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d71f8",
  null
  
)

export default component.exports